export default __webpack_public_path__ + "media/images/images/flags/ky-e4823a937a07afd747423a8c1c73279a.png";